// page builder framework theme js
import "./components/site-min.js";

// you can import modules from the theme lib or even from
// NPM packages if they support it…
//import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
//const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

// slick carousel
import slick from "slick-carousel";

// gsap
// import gsap from "gsap";
import "./components/gsap";


import slickSliderLoopNavigazione from "./components/slider/slick-offerte.js";
var sliderNav = new slickSliderLoopNavigazione();

// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });

(function ($) {
  // Add your custom scripts here.
  // This file will be compiled and is part of the gulp workflow.
  // If you're not using gulp, please make your changes directly to the site-child.js file in the main js folder.
})(jQuery);
